import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const EditIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="M3.051 9.684a1 1 0 0 1 .242-.391l9-9a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3Zm.95.316 6.645-6.646 2 2 .708-.708-2-2L13 1l2 2-9 9-3 1 1-3Z"
    />
    <path d="M1.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" />
  </IconWrapper>
)

export default EditIconSmall
